import { render, staticRenderFns } from "./LabelButton.vue?vue&type=template&id=99981814&"
import script from "./LabelButton.vue?vue&type=script&lang=ts&"
export * from "./LabelButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports